import axiosInstance from '@/Utils/axiosInstance';
import { notification_actions } from '@/constants/notificationsActions';

export const NotificationService = {
  getNotificationsTemplates: async (
    page = 1,
    limit = 8,
    searchTerm = '',
    sortBy = '',
    sortOrder = '',
    filters = {}
  ) => {
    try {
      const params = {
        page,
        limit,
        ...filters,
      };

      if (searchTerm) params.search = searchTerm;
      if (sortBy) params.sortBy = sortBy;
      if (sortOrder) params.sortOrder = sortOrder;

      const response = await axiosInstance.get(`/notifications/all-templates`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error('Get Notifications error:', error);
      throw error;
    }
  },

  getNotificationStats: async () => {
    try {
      const response = await axiosInstance.get(`/notifications/notifications-stats`);
      return response.data;
    } catch (error) {
      console.error('Get Notification Stats error:', error);
      throw error;
    }
  },

  deleteNotificationTemplate: async (templateId) => {
    try {
      const response = await axiosInstance.delete(`/notifications/${templateId}`);
      return response.data;
    } catch (error) {
      console.error('Delete Notification Template error:', error);
      throw error;
    }
  },

  getNotificationsToExport: async () => {
    try {
      const response = await axiosInstance.get(`/notifications/all-templates-to-export`);
      return response.data;
    } catch (error) {
      console.error('Get Notifications to Export error:', error);
      throw error;
    }
  },
  estimateUsersNumber: async (filters = {}) => {
    console.log(filters);
    try {
      const response = await axiosInstance.post(`/notifications/users-numbers-estimate`, filters);
      return response.data.data;
    } catch (error) {
      console.error('Estimate Users Number error:', error);
      throw error;
    }
  },

  addUsersToWhitelist: async (user_id) => {
    try {
      const response = await axiosInstance.post(`/user-allowlist`, { user_id });
      return response.data;
    } catch (error) {
      console.error('Add Users to Whitelist error:', error);
      throw error;
    }
  },

  removeUsersFromWhitelist: async (user_id) => {
    try {
      const response = await axiosInstance.delete(`/user-allowlist`, { data: { user_id } });
      return response.data;
    } catch (error) {
      console.error('Remove Users from Whitelist error:', error);
      throw error;
    }
  },

  getWhitelist: async () => {
    try {
      const response = await axiosInstance.get(`/user-allowlist`);
      return response.data;
    } catch (error) {
      console.error('Get Whitelist error:', error);
      throw error;
    }
  },

  getAllOffers: async () => {
    try {
      const response = await axiosInstance.get(`/offers/all`);
      return response.data.data;
    } catch (error) {
      console.error('Get All Offers error:', error);
      throw error;
    }
  },

  getAllCategories: async () => {
    try {
      const response = await axiosInstance.get(`/categories/all`);
      console.log('res: ', response.data.data);
      return response.data.data;
    } catch (error) {
      console.error('Get All Categories error:', error);
      throw error;
    }
  },

  getCtaOptions: async () => {
    try {
      const response = await axiosInstance.get(`/notifications/cta-options`);
      return response.data.data;
    } catch (error) {
      console.error('Get CTA Options error:', error);
      throw error;
    }
  },

  sendTestNotification: async (formData) => {
    try {
      const fd = new FormData();
      formData.title_en && fd.append('title_en', formData?.title_en ?? '');
      formData.message_en && fd.append('message_en', formData?.message_en ?? '');
      formData.title_ar && fd.append('title_ar', formData?.title_ar ?? '');
      formData.message_ar && fd.append('message_ar', formData?.message_ar ?? '');
      fd.append('language', formData?.language ?? 'both');
      fd.append('cta', String(formData?.cta ?? notification_actions.HOME_SCREEN.id));
      if (formData?.cta_url) {
        fd.append('cta_url', formData.cta_url);
      }
      if (formData?.cta_offer_id) {
        fd.append('cta_offer_id', formData.cta_offer_id);
      }
      if (formData?.cta_ad_id) {
        fd.append('cta_ad_id', formData.cta_ad_id);
      }
      if (formData?.cta_category_id) {
        fd.append('cta_category_id', formData.cta_category_id);
      }
      fd.append('scheduling_type', 'instant');
      fd.append('audience_type', formData?.audience_type ?? 'single_users');
      formData?.test_audience_list?.forEach((id) => {
        fd.append('test_audience_list', id);
      });
      if (formData?.image) {
        fd.append('image', formData.image);
      }

      const response = await axiosInstance.post(`/notifications`, fd);
      return response.data;
    } catch (error) {
      console.error('Send Test Notification error:', error);
      throw error;
    }
  },

  sendNotification: async (formData) => {
    try {
      const fd = new FormData();
      formData.audience_type &&
        fd.append('audience_type', formData?.audience_type ?? 'single_users');

      // Send filters at top level
      if (formData.audience_type === 'user_group') {
        const filters = {
          gender: formData.gender || undefined,
          age_group:
            formData.age_group === '13_24'
              ? '13-24'
              : formData.age_group === '25_30'
                ? '25-30'
                : formData.age_group === '30_plus'
                  ? '30+'
                  : undefined,
          subscription_status:
            formData.subscription_status === 'subscribe'
              ? true
              : formData.subscription_status === 'unsubscribe'
                ? false
                : undefined,
          region:
            formData.region === 'egypt'
              ? 'EG'
              : formData.region === 'ksa'
                ? 'SA'
                : formData.region === 'row'
                  ? 'ROW'
                  : undefined,
          activity_status: formData.activity_status || undefined,
          patient_group:
            formData.target_condition === 'diabetes'
              ? 'DM'
              : formData.target_condition === 'weight_loss'
                ? 'LW'
                : formData.target_condition === 'wellness'
                  ? 'FB'
                  : undefined,
        };
        fd.append('filters', JSON.stringify(filters));
      }

      formData.title_en && fd.append('title_en', formData?.title_en ?? '');
      formData.message_en && fd.append('message_en', formData?.message_en ?? '');
      formData.title_ar && fd.append('title_ar', formData?.title_ar ?? '');
      formData.message_ar && fd.append('message_ar', formData?.message_ar ?? '');
      fd.append('language', formData?.language ?? 'both');
      fd.append('cta', String(formData?.cta ?? notification_actions.HOME_SCREEN.id));
      if (formData?.cta_url) {
        fd.append('cta_url', formData.cta_url);
      }
      if (formData?.cta_offer_id) {
        fd.append('cta_offer_id', formData.cta_offer_id);
      }
      if (formData?.cta_ad_id) {
        fd.append('cta_ad_id', formData.cta_ad_id);
      }
      if (formData?.cta_category_id) {
        fd.append('cta_category_id', formData.cta_category_id);
      }
      fd.append('scheduling_type', formData?.scheduling_type ?? 'instant');
      formData.schedule_date && fd.append('schedule_date', formData?.schedule_date ?? '');
      formData.schedule_time && fd.append('schedule_time', formData?.schedule_time ?? '');
      formData.notification_id && fd.append('notification_id', formData?.notification_id ?? null);
      const audienceListIds = Array.isArray(formData?.audience_list)
        ? formData.audience_list.map((id) => id._id)
        : [];
      audienceListIds.forEach((id) => {
        fd.append('audience_list', id);
      });
      formData.image && fd.append('image', formData.image);
      const response = await axiosInstance.post(`/notifications`, fd);
      return response;
    } catch (error) {
      console.error('Send Notification error:', error);
      throw error;
    }
  },
};
